import React from "react";
import { Box, Typography, Paper } from "@mui/material";

const FieldGuide = () => {
  return (
    <Box>
      <Typography variant="h3" gutterBottom className="vintage-script-header">
        Field Guide
      </Typography>
      
      <Paper sx={{
        p: 3,
        background: 'transparent',
        border: '2px solid var(--color-border-vintage)',
        borderRadius: 0,
        boxShadow: 'none',
        position: 'relative'
      }}>
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          height: '4px',
          background: 'linear-gradient(90deg, var(--color-accent-gold) 0%, transparent 50%, var(--color-accent-gold) 100%)'
        }}></div>
        
        <Typography variant="body1" sx={{
          fontFamily: 'var(--font-serif)',
          color: 'var(--color-ink)',
          lineHeight: 1.6,
          mt: 2
        }}>
          Welcome to the Field Guide - your comprehensive botanical companion for gardening success. 
          This guide contains essential knowledge and practical tips to help you make the most of your garden.
        </Typography>
        
        <Typography variant="body1" sx={{
          fontFamily: 'var(--font-serif)',
          color: 'var(--color-ink)',
          lineHeight: 1.6,
          mt: 2
        }}>
          Explore the topics in the navigation menu to learn more about how to use the Agritur app 
          and the theories around managing your garden effectively. Each section provides detailed 
          guidance on different aspects of garden management.
        </Typography>
        
        <Typography variant="body1" sx={{
          fontFamily: 'var(--font-serif)',
          color: 'var(--color-ink)',
          lineHeight: 1.6,
          mt: 2
        }}>
          Whether you're a beginner or an experienced gardener, these guides will help you 
          understand the principles of successful gardening and how to apply them using 
          Agritur's powerful tools and features.
        </Typography>
      </Paper>
    </Box>
  );
};

export default FieldGuide;
